import axios from "../../../utils/request"

function GET_LIST(params) {
    return axios.get("/news/ANews/index", {
        params: {
            ...params
        }
    } )
}
function ADD_DATA(params) {
    return  axios.get("/news/ANews/add",{
        params: {}
    } )
}
function EDIT_DATA(params) {
    return  axios.get("/news/ANews/edit",{
        params: {id:params}
    } )
}
function SUBMIT_ADD(params) {
    return  axios.post("/news/ANews/addPost",{...params} )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/news/ANews/editPost",{...params} )
}


function CHANG_STATUS (params,type) {
    return  axios.post("/news/ANews/statusEdit", {status:params}  )
}
function DELE(params) {
    return  axios.get("/news/ANews/delete",{
        params: {
            ids:params
        }
    } )
}
function CHANG_TOP (params) {
    return  axios.post("/news/ANews/topEdit",{is_top:params} )
}
export default {
    GET_LIST,
    ADD_DATA,
    EDIT_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    CHANG_STATUS,
    DELE,
    CHANG_TOP
}
